import React from 'react';
import Header from './components/Header';
import Intro from './components/Intro';
import About from './components/About';
import Gallery from './components/Gallery';
import ImageGrid from './components/ImageGrid';
import Stats from './components/Stats';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-16">
        <Intro />
        <About />
        <Gallery />
        {/* <ImageGrid /> */}
        <Stats />
        <Footer />
      </main>
    </div>
  );
}

export default App;